import { IFeeds } from './sharedTypes'
import type { CamelCasedPropertiesDeep } from 'type-fest'

export type GetPage = (url: string) => Promise<CamelCasedPropertiesDeep<IFeeds>>
